export default __webpack_public_path__ + "static/api-features.url-c6a23452d3d2d805840f084f2c1c39b6.svg";